import { deepDive } from "@/mocks/chigua";
import Reveal from "./Reveal";

export default function DeepDive() {
  return (
    <section id="dive" className="scroll-mt-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <div className="overflow-hidden rounded-2xl bg-foreground-950 text-background-50 md:rounded-3xl">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              <div className="relative min-h-[280px] overflow-hidden lg:min-h-full">
                <img
                  src={deepDive.image}
                  alt={deepDive.alt}
                  className="absolute inset-0 h-full w-full object-cover object-center"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-transparent"></div>
                <span className="absolute left-5 top-5 inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 font-label text-xs font-black text-foreground-950">
                  <i className="ri-search-line"></i>
                  编辑部独家调查
                </span>
              </div>
              <div className="flex flex-col justify-center p-6 md:p-10">
                <p className="font-label text-xs font-bold uppercase tracking-[0.25em] text-accent-400">
                  {deepDive.eyebrow}
                </p>
                <h2 className="mt-3 font-heading text-2xl font-black leading-snug text-background-50 md:text-3xl">
                  {deepDive.title}
                </h2>
                <p className="mt-4 text-sm leading-relaxed text-background-200/90 md:text-[15px]">
                  {deepDive.body}
                </p>
                <ul className="mt-5 space-y-2.5">
                  {deepDive.points.map((p, idx) => (
                    <li key={p} className="flex items-start gap-2.5 text-sm text-background-100">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary-500 font-label text-[11px] font-bold text-background-50">
                        {idx + 1}
                      </span>
                      {p}
                    </li>
                  ))}
                </ul>
                <blockquote className="mt-6 border-l-4 border-accent-500 pl-4 font-heading text-lg font-bold italic text-accent-200">
                  {deepDive.quote}
                </blockquote>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}